import { Flex, Heading, Text } from '@backend/lib-design-system';
import { Features } from '@backend/lib-feature-mgr';
import { styled } from 'styled-components';

import { DownloadApp } from '~/components/DownloadApp';
import { useCheckFeatureEnabled, useTranslation } from '~/hooks';

const MissionListNoMissionsImage = styled.img`
  height: 9.75rem;
`;

const MissionListNoMissionsText = styled(Text)`
  width: 31rem;
`;

export const MissionListNoMissions = () => {
  const t = useTranslation();
  const appToDownloadFeature = useCheckFeatureEnabled(Features.JobOfferAppToDownload);

  return (
    <Flex.Column space="xl">
      <Flex.Row justifyContent="center" space="l">
        <MissionListNoMissionsImage src="/images/no-mission.png" alt="No missions" />
      </Flex.Row>
      <Heading textAlign="center" variant="heading-4">
        {t('no_missions_result.title')}
      </Heading>
      <Flex.Row justifyContent="center" space="xs">
        <MissionListNoMissionsText textAlign="center" variant="body-lighter">
          {t('no_missions_result.subtitle')} {appToDownloadFeature && t('no_missions_result.download_hint')}
        </MissionListNoMissionsText>
      </Flex.Row>
      {appToDownloadFeature && (
        <>
          <Heading textAlign="center" variant="subtitle">
            {t('no_missions_result.download_app')}
          </Heading>
          <DownloadApp justifyContent="center" />
        </>
      )}
    </Flex.Column>
  );
};
